import { useState } from 'react';
type GenericObject = { [key: string]: any };

export const useApi = (
    apiAction: () => Promise<object>,
    resolveMethod?: (res: GenericObject) => void,
): { response: any; fetchMethod: () => void } => {
    const [response, setResponse] = useState({ data: {}, isLoading: false, error: {}, isSuccess: false });

    const fetchMethod = () => {
        setResponse({
            data: {},
            isLoading: true,
            error: {},
            isSuccess: false,
        });

        apiAction()
            .then((res: object) => {
                setResponse({
                    data: res,
                    isLoading: false,
                    error: {},
                    isSuccess: true,
                });
                resolveMethod && resolveMethod(res);
            })
            .catch((err: object) => {
                setResponse({
                    data: {},
                    isLoading: false,
                    error: err,
                    isSuccess: false,
                });
            });
    };

    return { response, fetchMethod };
};
